import {
	ApostropheProvider, Typography
} from '@apostrophe/ui';
import { get } from 'lodash';
import React, {
	useEffect,useState
} from 'react';

import Submit from '../../Submit';
import ApplePay from '../ApplePay';
import withPaymentLogic from '../PaymentLogicHOC';
import Paypal from '../Paypal';
import CreditCardForm from '../Stripev3';
import BraintreeUI from '../ui/Braintree';
import StripeUI from '../ui/Stripe';
import { Title } from '../Version3/styles';
import {
	ButtonWrapper,
	Divider,
	ErrorState,
	FinePrint,
	NewCheckoutWrapper,
	Spacer,
	TitleContainer,
	UpdatedTitle,
} from './styles';

const Button = ({
	className, ...props
}) => (
	<ButtonWrapper className={className}>
		<Submit {...props} />
	</ButtonWrapper>
);

const NewPayments = (props) => {
	const [stripe, setStripe] = useState(null);
	const {
		mountStripe,
		mountPaypal,
		defaultPaymentMethod,
		showStoredPayment,
		hasBrowserPay,
		stripeInfo,
		braintreeInfo,
		defaultOnly,
		darkMode,
		paymentInfo,
		toggleStoredPayment,
		updatePaymentInfo,
		saveOnly,
		btnContainer,
		buttonPortal,
		medCheckout,
		otcCheckout,
		cartBypassProductsToSendToAjaxPrepayEndpoint,
		isFollowupv2,
		isPrepay,
	} = props;

	useEffect(() => {
		if (window.Stripe) {
			setStripe(window.Stripe(props.stripePublicKey))
		} else {
			document.querySelector('#stripe-js').addEventListener('load',
				() => {
				// Create Stripe instance once Stripe.js loads
					setStripe(window.Stripe(props.stripePublicKey));
				});
		}
	},
	[]);
	if (!stripe) { return null;}

	const useUpdatedRegistration = get(window,
		'Yoderm.data.useUpdatedRegistration') || false;

	if (showStoredPayment) {
		return (
			<NewCheckoutWrapper isPrepay={isPrepay} medCheckout={medCheckout} data-cy={'NewCheckoutWrapper'}>
				{!(otcCheckout || isPrepay) && <Title medCheckout={medCheckout} data-cy={'Title'}>{medCheckout ? 'Payment Method' : 'Payment'} </Title>}
				{isPrepay && <div data-cy={'Title'}><ApostropheProvider><Typography weight="medium">Pay with credit or debit card:</Typography></ApostropheProvider></div>}
				{isPrepay && <Spacer/>}
				{defaultPaymentMethod === 'stripe' &&
          <StripeUI
          	open={() => toggleStoredPayment(false)}
          	info={stripeInfo}
          	darkMode={darkMode}
          	isFollowupv2={isFollowupv2}
          	medCheckout={medCheckout}
          	isPrepay={isPrepay}
          	data-cy={'StripeUI'}
          />
				}
				{defaultPaymentMethod === 'braintree' &&
          <BraintreeUI
          	open={() => toggleStoredPayment(false)}
          	info={braintreeInfo}
          	isFollowupv2={isFollowupv2}
          	darkMode={darkMode}
          	medCheckout={medCheckout}
          	data-cy={'BraintreeUI'}
          />
				}
				{!saveOnly && (
					<>
						{buttonPortal && btnContainer.current ?
							ReactDOM.createPortal(<Button {...props} />,
								btnContainer.current)
							: (
								<Button {...props} />
							)}
					</>
				)}
			</NewCheckoutWrapper>
		)
	} else {
		return (
			<>
				<TitleContainer medCheckout={medCheckout} isPrepay={isPrepay} useUpdatedRegistration={useUpdatedRegistration} data-cy={'TitleContainer'}>
					{!(otcCheckout || isPrepay) && !useUpdatedRegistration &&
						<Title medCheckout={medCheckout} data-cy={'Title'}>
							{medCheckout ? 'Payment Method' : 'Payment'}
						</Title>}
					{isPrepay && <div data-cy={'Title'}><ApostropheProvider><Typography weight="medium">Pay with credit or debit card:</Typography></ApostropheProvider></div>}
					{paymentInfo && paymentInfo.defaultPaymentMethod &&
						<a onClick={() => toggleStoredPayment(true)}>
						  Cancel
						</a>
					}
				</TitleContainer>
				{paymentInfo && paymentInfo.shipping && !paymentInfo.defaultPaymentMethod &&
            <ErrorState>
              It looks like you have no form of payment saved. Please add payment method below. This will be your default payment method
              moving forward.
            </ErrorState>
				}
				{mountStripe &&
            <>
            	<Spacer/>
            	<ApplePay
            		{...props}
            		reportProperty="hasBrowserPay"
            		propogatePaymentInfo={updatePaymentInfo}
            		data-cy={'ApplePay'}
            	/>
            	<Spacer/>
            </>
				}
				{(!isPrepay && (mountPaypal || !paymentInfo.defaultPaymentMethod)) &&
            <Paypal
            	{...props}
            	reportProperty="hasPaypal"
            	propogatePaymentInfo={updatePaymentInfo}
            	otcCheckout={otcCheckout}
            	data-cy={'Paypal'}
            />
				}

				{(!isPrepay && (((mountPaypal || hasBrowserPay) && mountStripe && !otcCheckout) || !paymentInfo.defaultPaymentMethod)) &&
            <div>
            	{useUpdatedRegistration ?
            		(<Typography style={{ margin: '16px 0px' }} align={'center'} variant={'body1'}>OR</Typography>)
					  :
            		(<Divider medCheckout={props.medCheckout} darkMode={darkMode}><span>OR</span></Divider>)}
            </div>
				}
				{(mountStripe || !paymentInfo.defaultPaymentMethod) &&
            <CreditCardForm
            	{...props}
            	buttonPortal={buttonPortal}
            	btnContainer={btnContainer}
            	propogatePaymentInfo={updatePaymentInfo}
            	otcCheckout={otcCheckout}
            	data-cy={'CreditCardForm'}
            />
				}
				{defaultOnly && mountPaypal &&
            <FinePrint data-cy={'FinePrint'}>
              To switch your payment provider from Paypal to a credit card,
              send us a message in your Patient Dashboard or send us an email at <a href="mailto:care@apostrophe.com">care@apostrophe.com</a>
            </FinePrint>
				}
			</>
		)
	}
};

NewPayments.defaultProps = {
	saveOnly: false,
};

export default withPaymentLogic(NewPayments)
